import React from "react";

const CloseButton = (props) => {
  const { onClose } = props;
  return (
    <button
      type="button"
      className="close ml-auto"
      data-dismiss="modal"
      aria-label="Close"
      onClick={() => onClose()}
    >
      <span aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="#002F70"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </span>
    </button>
  );
};

export default CloseButton;
